import { render, staticRenderFns } from "./MatchedPartnerCard.vue?vue&type=template&id=7f737589&scoped=true"
import script from "./MatchedPartnerCard.vue?vue&type=script&lang=js"
export * from "./MatchedPartnerCard.vue?vue&type=script&lang=js"
import style0 from "./MatchedPartnerCard.vue?vue&type=style&index=0&id=7f737589&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f737589",
  null
  
)

export default component.exports